<template>
  <!--
          作者：kmdshop
          时间：2019-10-25
          描述：会员-添加
      -->
  <el-dialog
    title="添加发送任务"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      size="small"
      :model="form"
      :rules="rules"
      ref="form"
      v-loading="formLoading"
    >

    <el-form-item label="任务名称" :label-width="formLabelWidth" prop="name">
        <el-input type="text" v-model="form.name" autocomplete="off" ></el-input>
      </el-form-item>


      <!-- 固定格式 -->
      <el-form-item    label="短信签名" :label-width="formLabelWidth" prop="sign_id">
        <!-- <el-select v-model="form.sign_id"  >
          <el-option v-for="item in options" :value="item.path"  :label="item.name"   :key="item.api_id" ></el-option>
        </el-select> -->
      </el-form-item>

      <el-form-item    label="短信模板" :label-width="formLabelWidth" prop="template_id">
        <!-- <el-select v-model="form.template_id" >
          <el-option v-for="item in options" :value="item.path"  :label="item.name"   :key="item.api_id" ></el-option>
        </el-select> -->
      </el-form-item>

    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="submitApi" :loading="loading"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import SmsApi from "@/api/sms.js";
export default {
  data() {
    return {
      form: {
        name:"",
        sign_id:0,//短信签名
        template_id:0,//短信模板
      },
      rules: {
        "name": [
          { required: true, message: "请输入任务名称", trigger: "blur" }
        ],
        "sign_id": [
          { required: true, message: "请选择短信签名", trigger: "blur" }
        ],
        "template_id": [{ required: true, message: "请选择短信模板", trigger: "blur" }]
      },
      /*左边长度*/
      formLabelWidth: "100px",
      /*是否显示*/
      dialogVisible: false,
      loading: false,
      formLoading: false
    };
  },
  props: ["open_add"],
  
  created() {
    this.init();
  },

  methods: {
  /* 初始化数据 */
    async init() {
        this.dialogVisible = this.open_add;
    },
    // 提交api表单
    submitApi() {
      var self = this;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          SmsApi.add(self.form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '恭喜你，添加成功',
                type: 'success'
              });
              self.dialogFormVisible()
            })
            .catch(error => {
              self.loading = false;
            });
        } else {
          return false;
        }
      });
    },


    /*关闭弹窗*/
    dialogFormVisible() {
      this.$emit("closeDialog");
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/data/sms/index/task/add.vue